import dotAccess from 'dot-access';
import moment from 'moment';

export const notNullValidatorCancMutag = (field, message) => (obj, err) => {
 const value = dotAccess.get(obj, field);
 
 if(obj !== undefined && obj !== null){
	 //Mutag or Canc.
	 if ((obj.isSubstanceCancerous || obj.isSubstanceCancerous == null || obj.isSubstanceCancerous === undefined) ||
			  (obj.isSubstanceMutagen || obj.isSubstanceMutagen == null || obj.isSubstanceMutagen === undefined)){
		 if ((value === undefined || value === null) && (
				 field === "revelationCollectiveProtectionFactor" ||
				 field === "revelationProcessTemperature" ||
				 field === "revelationChemicalPhysicalState" ||
				 field === "revelationAmountUsed" ||
				 field === "revelationHandlingTimeMinutes" ||
				 field === "revelationFrequencyOfUseDays")){

			 dotAccess.set(err, 'errors.' + field, message);
			 err.hasErrors = true;
		 }
	 }else{
		 if ((value === undefined || value === null) && (
				 field === "inhalationDistance" ||
				 field === "inhalationQuantity" ||
				 field === "inhalationProperty" ||
				 field === "inhalationSystemType" ||
				 field === "inhalationControlType" ||
				 field === "inhalationExposureTime" ||
				 field === "skinSystemType" ||
				 field === "skinContactLevel" )){
			
			 dotAccess.set(err, 'errors.' + field, message);
			 err.hasErrors = true;
			 
		 }
	 }
 }
// 	if (value === undefined || value === null) {
//	  dotAccess.set(err, 'errors.' + field, message);
//	  err.hasErrors = true;
//	}
}

export const notNull = (field, message) => (obj, err) => {
  const value = dotAccess.get(obj, field);
  if (value === undefined || value === null) {
    dotAccess.set(err, 'errors.' + field, message);
    err.hasErrors = true;
  }
};

export const notEmpty = (field, message) => (obj, err) => {
  const value = dotAccess.get(obj, field);
  if (value === undefined || value === null || (Array.isArray(value) && value.length < 1)) {
    dotAccess.set(err, 'errors.' + field, message);
    err.hasErrors = true;
  }
};

export const notEmptyForRoleG = (field, message) => (obj, err) => {
  const roles = dotAccess.get(obj, 'roles');
  notEmpty('roles', message);
  if(!err.hasErrors && roles.includes("G")){
    const value = dotAccess.get(obj, field);
    if (value === undefined || value === null || (Array.isArray(value) && value.length < 1)) {
      dotAccess.set(err, 'errors.' + field, message);
      err.hasErrors = true;
    }
  }
};

export const stringNotBlank = (field, message) => (obj, err) => {
  const value = dotAccess.get(obj, field);
  if (value === undefined || value === null || !String(value).trim()) {
    dotAccess.set(err, 'errors.' + field, message);
    err.hasErrors = true;
  }
};

export const validDate = (field, message) => (obj, err) => {
  const value = dotAccess.get(obj, field);
  const isMoment = moment.isMoment(value);

  if (value === undefined || value === null || value === '') {
    return;
  }

  if ((!isMoment && !moment(value).isValid()) || (isMoment && !value.isValid())) {
    dotAccess.set(err, 'errors.' + field, message);
    err.hasErrors = true;
  }
};

export const stringValidEmail = (field, message) => (obj, err) => {
  const value = dotAccess.get(obj, field);

  const emailRegex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

  if (value === undefined || value === null || !emailRegex.test(value)) {
    dotAccess.set(err, 'errors.' + field, message);
    err.hasErrors = true;
  }
};

export const warnStringNotBlank = (field, message) => (obj, err) => {
  const value = dotAccess.get(obj, field);
  if (value === undefined || value === null || !String(value).trim()) {
    dotAccess.set(err, 'warnings.' + field, message);
    err.hasWarnings = true;
  }
};

export const minValue = (field, min, message) => (obj, err) => {
  const value = dotAccess.get(obj, field);
  if (value === undefined || value === null || value < min) {
    dotAccess.set(err, 'errors.' + field, message);
    err.hasErrors = true;
  }
};

export const nullValidator = () => (obj, err) => {

}



// WEBPACK FOOTER //
// ./src/main/cruds/validators.js